import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'
import { formatScore, getRiskLevel } from '../types'

type Props = {
  data: any
}

export default function RiskScoreTable({ data }: Props) {
  const theme = useTheme()
  const score = Number(data?.xyp_cpl0081)

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        信用风险概览
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>指标</Table.Th>
            <Table.Th style={{ width: '60%' }}>结果</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>信用风险评分</Table.Td>
            <Table.Td>{formatScore(score)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>风险等级</Table.Td>
            <Table.Td style={{ color: score >= 0.5 ? theme.warningColor : theme.primaryColor }}>
              {getRiskLevel(score)}
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
